const showDropdown = (id) => {
	document.getElementById(id).classList.add('sfHover');
}